import React, { useEffect } from "react";
import "./mspClientAccessLevel.scss";
import { useState } from "react";
import MspAccessLevelModal from "./MspAccessLevelModal";
import { getAPIData } from "../../../Utils/commonApi";
import { useAuth } from "../../context/Auth";
import MembersPageLoader from "../../settingsV2/members/MembersPageLoader";
import { getAccessStateValue } from "../../App/App";
import { CallToast } from "../../PriceCalculator/modals/CustomToast";
import UsersInUseModal from "../../Common/users-in-use-modal/users-in-use.modal";
import RolesBlock from "./Components/RolesBlock";
import HeaderWithAddButton from "../Components/HeaderWithAddButton";
import useUserDetails from "../../../hooks/user-details.hook";
import useActions from "../../../hooks/service-actions.hook";
import { ClientAccessRolesDetailsEffectActions } from "../../../common/services/client-access-roles-details/client-access-roles-details.service";
import { useEntity } from "../../../hooks/use-entity.hook";
import { Entities } from "../../../common/store/entities/entities.enum";

export const RoleAction = {
  Duplicate: 0,
  Delete: 1,
}

const MSPClientAccessLevels = ({ isView = false }) => {
  const { clientId } = useUserDetails();
  const { getAccessRolesDetails } = useActions(ClientAccessRolesDetailsEffectActions);
  const { entityData: clientAccessRolesDetails } = useEntity({ entityType: Entities.ClientAccessRolesDetails, entityId: clientId });

  const { authTokens } = useAuth();
  const [showAccessLevelModal, setShowAccessLevelModal] = useState(false);
  const [accessLevelId, setAccessLevelId] = useState(0);
  const [roles, setRoles] = useState([]);
  const [deletemode, setdeletemode] = useState(false);
  const [updatingRoleLoading, setUpdatingRoleLoading] = useState({ roleId: null, action: null });
  const [usersInUseData, setUsersInUseData] = useState(null);
  const [dontAllowEdit, setDontAllowEdit] = useState(false);

  useEffect(() => {
    getAccessRolesData();
  }, []);
  useEffect(() => {
    if (roles.length < 2 && !showAccessLevelModal && deletemode) {
      window.location.reload();
    }
  }, [roles, showAccessLevelModal, deletemode]);
  function refreshData() {
    getAccessRolesData();
  }
  function refreshDataOnDelete() {
    setdeletemode(true);
    if (roles.length < 2) {
      setShowAccessLevelModal(false);
    } else {
      getAccessRolesData();
    }
  }

  async function duplicateRole(roleId) {
    setUpdatingRoleLoading({ roleId: roleId, action: RoleAction.Duplicate });
    await getAPIData(577, authTokens, {
      accessKey: JSON.parse(localStorage.getItem("user_MessageObj")),
      optionEnum1: roleId,
      optionEnum99: 5,
    }).then((response) => {
      setUpdatingRoleLoading({ roleId: null, action: null });
      if (response.Success) {
        getAccessRolesData();
      }
    });
  }

  async function deleteRole(roleID) {
    setUpdatingRoleLoading({ roleId: roleID, action: RoleAction.Delete });
    await getAPIData(578, authTokens, {
      accessKey: JSON.parse(localStorage.getItem("user_MessageObj")),
      optionEnum1: roleID,
      optionEnum99: 5,
    }).then((response) => {
      setUpdatingRoleLoading({ roleId: null, action: null });
      if (response?.mr?.Success) {
        getAccessRolesData();
        CallToast(response?.mr?.Message, false, false, "v2style");
      } else {
        if (response?.detail?.users) {
          setUsersInUseData(response?.detail);
        } else {
          if (response?.EntityId == -1) {
            CallToast(response?.Message, false, false, "v2style");
          } else {
            CallToast("Something went wrong", false, false, "v2style");
          }
        }
      }
    });
  }

  async function getAccessRolesData() {
    getAccessRolesDetails({ clientId, kwargs: { optionEnum1: 1 } });
  }

  useEffect(() => {
    if (!clientAccessRolesDetails) return;
    setRoles(clientAccessRolesDetails);
  }, [clientAccessRolesDetails]);
  
  return (
    <>
      {!clientAccessRolesDetails ? <MembersPageLoader /> : (
        <div className="msp_client_access_levels">
          <div className="f-16 f-600">Clients Access Roles</div>
          <HeaderWithAddButton
            header={'Access Roles'}
            buttonLabel={'Add access roles'}
            hideButton={isView}
            isDisable={getAccessStateValue("AccessState_MSP_User_Management") < 3}
            onButtonClick={() => {
              setAccessLevelId(0);
              setShowAccessLevelModal(true);
            }}
          />
          <RolesBlock
            data={roles}
            updatingRoleLoading={updatingRoleLoading}
            isView={isView}
            onItemClick={(item) => {
              if (!isView) {
                if (item?.IsDefault === 1) {
                  setDontAllowEdit(true);
                }
                setAccessLevelId(item?.objId_AccessRole);
                setShowAccessLevelModal(true);
              }
            }}
            onDuplicateRole={duplicateRole}
            onDeleteRole={deleteRole}
            onAccessLevelRole={(item) => {
              if (!isView) {
                setAccessLevelId(item?.objId_AccessRole);
                setShowAccessLevelModal(true);
              }
            }}
          />

          <MspAccessLevelModal
            accessLevelId={accessLevelId}
            show={showAccessLevelModal}
            hideModal={() => {
              setDontAllowEdit(false);
              setShowAccessLevelModal(false);
            }}
            parentID="msp-main-screen-for-integration-modal"
            refreshData={() => {
              setDontAllowEdit(false);
              refreshData();
            }}
            dontAllowEdit={dontAllowEdit}
            refreshDataOnDelete={() => {
              setDontAllowEdit(false);
              refreshDataOnDelete();
            }}
            setUsersInUseData={setUsersInUseData}
          />
          <UsersInUseModal
            show={usersInUseData !== null}
            onHide={() => setUsersInUseData(null)}
            data={usersInUseData}
            title="Access Role in use"
          />
        </div>
      )}
    </>
  );
};

export default MSPClientAccessLevels;
